import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import ExpandbleTabs from "common/components/ExpandbleTabs"
import { VALIDATION_REDIRECTION_ORIGINS } from "features/Validaciones/constants"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { CONTACTO_TABS, panels, tabs } from "../../constants/constants"

const { CONTABILIDAD, FINANCIACION, FACTURAS } = CONTACTO_TABS

const DatosAvanzados = ({
  contactoById,
  updateContactoById,
}: {
  contactoById: ContactoReadingDtoProps
  updateContactoById: () => void
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const redirectedFromFinanciacionPage =
    location.state?.from === VALIDATION_REDIRECTION_ORIGINS.FINANCIACION
  const [selected, setSelected] = useState(
    redirectedFromFinanciacionPage ? FINANCIACION : CONTABILIDAD
  )

  useEffect(() => {
    location.state?.selectedTab === FACTURAS && setSelected(FACTURAS)
  }, [location.state?.selectedTab, location.state?.clicked])

  return (
    <div className='tw-w-3/4 tw-h-full'>
      <ExpandbleTabs
        tabs={tabs(t)}
        panels={panels(contactoById, updateContactoById)}
        selected={selected}
        setSelected={setSelected}
      />
    </div>
  )
}

export default DatosAvanzados
